import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-License-Identifier: AGPL-3.0-or-later
import { useId } from 'react';
import { ExtensionUrl, findExtension } from '@intakeform/fhir';
import { Input } from '../../primitives/Input.js';
import { describedBy, FieldHost } from '../FieldHost.js';
function asNumber(v) {
    return typeof v === 'number' && Number.isFinite(v) ? v : undefined;
}
function readNumericExtension(item, url) {
    const ext = findExtension(item, url);
    if (ext === undefined)
        return undefined;
    if (typeof ext.valueDecimal === 'number')
        return ext.valueDecimal;
    if (typeof ext.valueInteger === 'number')
        return ext.valueInteger;
    return undefined;
}
export function NumberField(props) {
    const { item, value, errors, disabled, onChange } = props;
    const id = useId();
    const current = asNumber(value);
    const min = readNumericExtension(item, ExtensionUrl.minValue);
    const max = readNumericExtension(item, ExtensionUrl.maxValue);
    const step = item.type === 'integer' ? 1 : 'any';
    return (_jsx(FieldHost, { item: item, errors: errors, controlId: id, children: (ctx) => (_jsx(Input, { id: id, type: "number", inputMode: item.type === 'integer' ? 'numeric' : 'decimal', value: current === undefined ? '' : String(current), disabled: disabled === true, required: item.required === true, min: min, max: max, step: step, "aria-invalid": ctx.hasError || undefined, "aria-describedby": describedBy(ctx), onChange: (e) => {
                const raw = e.currentTarget.value;
                if (raw === '') {
                    onChange(undefined);
                    return;
                }
                const n = Number(raw);
                onChange(Number.isFinite(n) ? n : undefined);
            } })) }));
}
//# sourceMappingURL=NumberField.js.map